









import {Component, Prop, Vue} from "vue-property-decorator"
import {Site} from "@/interface"

@Component
export default class SiteImage extends Vue {

  @Prop({type: Object, default: null}) private site!: Site
  @Prop({type: Number, default: 100}) private size!: number

  get path() {
    return this.site.image
      ? "https://push.asahiinteractive.com/" + this.site.image
      : false
  }

  get style() {
    return {
      width: this.size + 'px',
      height: this.size + 'px'
    }
  }
}
